// extracted by mini-css-extract-plugin
module.exports = {"box_container":"styles_box_container__Lw7Pv","hide":"styles_hide__2c92P"};